var journalize = require('journalize');

import { capfirst, apdate, aptime, apmonth } from 'journalize';

import context from 'Data/text.json';

export function lastUpdatedFormat(now) {
  // format dates to ap style
  const formatted_date = journalize.apdate(now),
    formatted_time = journalize.aptime(now),
    formatted_month = journalize.apmonth(now),
    just_day = now.getDate();

  return formatted_time;
}

export function format(num) {
  return num < 10 ? '0' + num : num;
}

export const chunk = (arr, size) =>
  arr.reduce((acc, _, i) => {
    if (i % size === 0) acc.push(arr.slice(i, i + size));
    return acc;
  }, []);

export const delay = (function() {
    var timer = 0;
    return function(callback, ms) {
      clearTimeout(timer);
      timer = setTimeout(callback, ms);
    };
  })(); 

const PARTY_SORT_ORDER = [
  'democrat',
  'republican',
  'libertarian',
  'independent',
  'write-in',
];

let opacity = '0.4'

// export const CandidateColorsRace1 = [
//   {
//     name: 'Don Huffines',
//     color: '#FF822D',
//     rgbaColor: 'rgba(255,130,45,' + opacity + ')',
//     id: 'f2a01af6-9736-4746-807d-afa1c0712e86',
//   },
//   {
//     name: 'Paul Belew',
//     color: '#888888',
//     rgbaColor: 'rgba(136,136,136,' + opacity + ')',
//     id: '84ea6382-4423-4ce1-b7f5-246bd9f5b9cd',
//   },
//   {
//     name: 'Greg Abbott',
//     color: '#EF564A',
//     rgbaColor: 'rgba(239,86,74,' + opacity + ')',
//     id: '80a2b835-ddbd-42e1-92a3-cc11c9e0a753',
//   },
//   {
//     name: 'Danny Harrison',
//     color: '#888888',
//     rgbaColor: 'rgba(136,136,136,' + opacity + ')',
//     id: '188e5458-72c6-4d30-a037-255d3fef94cb',
//   },
//   {
//     name: 'Allen West',
//     color: '#fcbec3',
//     rgbaColor: 'rgba(252,190,195,' + opacity + ')',
//     id: 'b78206b9-e4f5-48aa-a473-7d3e0be8d465',
//   },
//   {
//     name: 'Rick Perry',
//     color: '#5acc7d',
//     rgbaColor: 'rgba(90,204,125,' + opacity + ')',
//     id: '0b3abed7-6782-4961-8260-e8f3b788877e',
//   },
//   {
//     name: 'Chad Prather',
//     color: '#888888',
//     rgbaColor: 'rgba(136,136,136,' + opacity + ')',
//     id: 'cc2d3c2e-0f45-4a74-aa26-8c3ee4f8062a',
//   },
//   {
//     name: 'Kandy Kaye Horn',
//     color: '#888888',
//     rgbaColor: 'rgba(136,136,136,' + opacity + ')',
//     id: 'ccb12f02-0f03-44a8-9ab1-7d9be79a9e9f',
//   },
// ];

// export const CandidateColorsRace2 = [
//   {
//     name: 'Eva Guzman',
//     color: '#FF822D',
//     rgbaColor: 'rgba(255,130,45,' + opacity + ')',
//     id: '3e039708-b4ec-422b-92e1-f8663b210e68',
//   },
//   {
//     name: 'Ken Paxton',
//     color: '#EF564A',
//     rgbaColor: 'rgba(239,86,74,' + opacity + ')',
//     id: '3b28dedf-7932-4aa8-9385-9be66435b2e6',
//   },
//   {
//     name: 'George P. Bush',
//     color: '#fcbec3',
//     rgbaColor: 'rgba(252,190,195,' + opacity + ')',
//     id: 'ee835f10-288e-490e-93b5-edc1ef494f9e',
//   },
//   {
//     name: 'Louie Gohmert',
//     color: '#5acc7d',
//     rgbaColor: 'rgba(90,204,125,' + opacity + ')',
//     id: '0f091680-e674-4332-8ebf-2c10ca941cb5',
//   },
// ];

// Possible final version for Republic


export const CandidateColorsRace1 = [
  {
    name: 'Don Huffines',
    color: '#FF822D',
    rgbaColor: 'rgba(255,130,45,' + opacity + ')',
    id: 'dd9995bf-1a87-4886-a2ba-6bdc6eb5f446',
  },
  {
    name: 'Paul Belew',
    color: '#bababa',
    rgbaColor: 'rgba(186,186,186,' + opacity + ')',
    id: 'e4cd9060-4edc-4a30-968d-72730e4e4c0c',
  },
  {
    name: 'Greg Abbott',
    color: '#EF564A',
    rgbaColor: 'rgba(239,86,74,' + opacity + ')',
    id: '0f9045b5-e67c-42d9-aa17-f33a22befd04',
  },
  {
    name: 'Danny Harrison',
    color: '#bababa',
    rgbaColor: 'rgba(186,186,186,' + opacity + ')',
    id: 'fd4fe5df-2bcf-466d-b8b1-7344ab2f6414',
  },
  {
    name: 'Allen West',
    color: '#fcbec3',
    rgbaColor: 'rgba(252,190,195,' + opacity + ')',
    id: '656607e0-d138-4cee-b84f-cdd0350b96fe',
  },
  {
    name: 'Rick Perry',
    color: '#5acc7d',
    rgbaColor: 'rgba(90,204,125,' + opacity + ')',
    id: '8bc0da48-e6c1-498b-ab81-4aadf7d638e5',
  },
  {
    name: 'Chad Prather',
    color: '#bababa',
    rgbaColor: 'rgba(186,186,186,' + opacity + ')',
    id: '16f5724f-7d28-492b-b7bd-2d335bbd9697',
  },
  {
    name: 'Kandy Kaye Horn',
    color: '#bababa',
    rgbaColor: 'rgba(186,186,186,' + opacity + ')',
    id: '09728391-8a1d-41c7-87f0-1fbe1bf52509',
  },
];

export const CandidateColorsRace2 = [
  {
    name: 'Eva Guzman',
    color: '#FF822D',
    rgbaColor: 'rgba(255,130,45,' + opacity + ')',
    id: 'ea05a6f9-e3f4-4906-af89-dbe174832de8',
  },
  {
    name: 'Ken Paxton',
    color: '#EF564A',
    rgbaColor: 'rgba(239,86,74,' + opacity + ')',
    id: 'bb5d7564-aacb-49a1-a48d-2382e247ea23',
  },
  {
    name: 'George P. Bush',
    color: '#fcbec3',
    rgbaColor: 'rgba(252,190,195,' + opacity + ')',
    id: 'a38afc36-b555-41f0-9e16-67431946e81f',
  },
  {
    name: 'Louie Gohmert',
    color: '#5acc7d',
    rgbaColor: 'rgba(90,204,125,' + opacity + ')',
    id: 'f474bda3-eec9-4012-be3d-b54d7369fc0e',
  },
];

// Another old version of Ids

// export const CandidateColorsRace1 = [
//   {
//     name: 'Don Huffines',
//     color: '#FF822D',
//     rgbaColor: 'rgba(255,130,45,' + opacity + ')',
//     id: 'f2a01af6-9736-4746-807d-afa1c0712e86',
//   },
//   {
//     name: 'Paul Belew',
//     color: '#bababa',
//     rgbaColor: 'rgba(186,186,186,' + opacity + ')',
//     id: '84ea6382-4423-4ce1-b7f5-246bd9f5b9cd',
//   },
//   {
//     name: 'Greg Abbott',
//     color: '#EF564A',
//     rgbaColor: 'rgba(239,86,74,' + opacity + ')',
//     id: '80a2b835-ddbd-42e1-92a3-cc11c9e0a753',
//   },
//   {
//     name: 'Danny Harrison',
//     color: '#bababa',
//     rgbaColor: 'rgba(186,186,186,' + opacity + ')',
//     id: '188e5458-72c6-4d30-a037-255d3fef94cb',
//   },
//   {
//     name: 'Allen West',
//     color: '#fcbec3',
//     rgbaColor: 'rgba(252,190,195,' + opacity + ')',
//     id: 'b78206b9-e4f5-48aa-a473-7d3e0be8d465',
//   },
//   {
//     name: 'Rick Perry',
//     color: '#5acc7d',
//     rgbaColor: 'rgba(90,204,125,' + opacity + ')',
//     id: '0b3abed7-6782-4961-8260-e8f3b788877e',
//   },
//   {
//     name: 'Chad Prather',
//     color: '#bababa',
//     rgbaColor: 'rgba(186,186,186,' + opacity + ')',
//     id: 'cc2d3c2e-0f45-4a74-aa26-8c3ee4f8062a',
//   },
//   {
//     name: 'Kandy Kaye Horn',
//     color: '#bababa',
//     rgbaColor: 'rgba(186,186,186,' + opacity + ')',
//     id: 'ccb12f02-0f03-44a8-9ab1-7d9be79a9e9f',
//   },
// ];

// export const CandidateColorsRace2 = [
//   {
//     name: 'Eva Guzman',
//     color: '#FF822D',
//     rgbaColor: 'rgba(255,130,45,' + opacity + ')',
//     id: '3e039708-b4ec-422b-92e1-f8663b210e68',
//   },
//   {
//     name: 'Ken Paxton',
//     color: '#EF564A',
//     rgbaColor: 'rgba(239,86,74,' + opacity + ')',
//     id: '3b28dedf-7932-4aa8-9385-9be66435b2e6',
//   },
//   {
//     name: 'George P. Bush',
//     color: '#fcbec3',
//     rgbaColor: 'rgba(252,190,195,' + opacity + ')',
//     id: 'ee835f10-288e-490e-93b5-edc1ef494f9e',
//   },
//   {
//     name: 'Louie Gohmert',
//     color: '#5acc7d',
//     rgbaColor: 'rgba(90,204,125,' + opacity + ')',
//     id: '0f091680-e674-4332-8ebf-2c10ca941cb5',
//   },
// ];

// Old version of ids

// export const CandidateColorsRace1 = [
//   {
//     name: 'Don Huffines',
//     color: '#FF822D',
//     id: 'c526e1ab-2912-496a-a3f4-92e0b308f2a2',
//   },
//   {
//     name: 'Paul Belew',
//     color: '#888888',
//     id: '101f68f4-7798-4b60-ae2a-7176e0a12078',
//   },
//   {
//     name: 'Greg Abbott',
//     color: '#EF564A',
//     id: '004f9cc0-90d0-4419-a402-882a41da1b3c',
//   },
//   {
//     name: 'Danny Harrison',
//     color: '#888888',
//     id: '5dab7e8a-8461-46a0-a1c5-7cd6e32d12ab',
//   },
//   {
//     name: 'Allen West',
//     color: '#fcbec3',
//     id: '0571fa38-1d78-4cb1-bfa9-9bca40316a8a',
//   },
//   {
//     name: 'Rick Perry',
//     color: '#5acc7d',
//     id: 'cc24e4df-5448-418d-b563-31a23f9ca268',
//   },
//   {
//     name: 'Chad Prather',
//     color: '#888888',
//     id: '38de444b-3de9-4a86-ab1e-303bac34da7c',
//   },
//   {
//     name: 'Kandy Kaye Horn',
//     color: '#888888',
//     id: '146178ae-3e68-460b-b5a3-7e544291d6ab',
//   },
// ];

// export const CandidateColorsRace2 = [
//   {
//     name: 'Eva Guzman',
//     color: '#FF822D',
//     id: '6df0e3a7-99e4-4354-8d53-8c40122ce139',
//   },
//   {
//     name: 'Ken Paxton',
//     color: '#EF564A',
//     id: '9a1c99d4-5dc0-40de-b8bf-6c8f0fb4dfad',
//   },
//   {
//     name: 'George P. Bush',
//     color: '#fcbec3',
//     id: 'cc743235-0cb1-4921-80dd-16aacab28c0e',
//   },
//   {
//     name: 'Louie Gohmert',
//     color: '#5acc7d',
//     id: '470b162e-f0d4-4f44-8fc8-427703e18765',
//   },
// ];

// If we need light blue #99d2da; background-color:rgba(153, 210, 218, .1)
// If we need dark blue #325ba8; background-color:rgba(90, 137, 204, .1)

const TT_directory_slugs = [
  { office: 'Texas House', 'directory-slug': 'tx-house' },
  { office: 'Texas Senate', 'directory-slug': 'tx-senate' },
  { office: 'U.S. House', 'directory-slug': 'us-house' },
  { office: 'State Board of Education', 'directory-slug': 'sboe' },
];

export function get_directory_slug(office) {
  return TT_directory_slugs.filter(slug => slug.office == office);
}

export function sort_candidates_by_party(candidates) {
  return candidates.sort(
    (a, b) =>
      PARTY_SORT_ORDER.indexOf(a.party) - PARTY_SORT_ORDER.indexOf(b.party)
  );
}

export function alert_conditionals(vote_pct, cand_num) {
  if (vote_pct == 0 && cand_num > 1) {
    return context.label_conditionals['zero-results'];
  } else if (vote_pct > 1 && vote_pct <= 50 && cand_num > 1) {
    return context.label_conditionals['more-than-0-less-than-50'];
  } else if (vote_pct > 50 && vote_pct < 99 && cand_num > 1) {
    return context.label_conditionals['more-than-50-no-winner'];
  } else if (vote_pct >= 99 && cand_num > 1) {
    return context.label_conditionals['all-results-in-no-winner'];
  } else if (cand_num == 1) {
    return context.label_conditionals['uncontested'];
  }
}

export function alert_winners(result) {
  if (result == 'winner') {
    return context.winner_conditionals['winner'];
  } else if (result == 'uncontested') {
    return context.winner_conditionals['uncontested'];
  } else if (result == 'runoff') {
    return context.winner_conditionals['runoff'];
  }
}

export function text_conditionals(vote_pct, cand_num) {
  if (vote_pct == 0 && cand_num > 1) {
    return context.text_conditionals['zero-results'];
  } else if (vote_pct > 1 && vote_pct <= 50 && cand_num > 1) {
    return context.text_conditionals['more-than-0-less-than-50'];
  } else if (vote_pct > 50 && vote_pct < 99 && cand_num > 1) {
    return context.text_conditionals['more-than-50-no-winner'];
  } else if (vote_pct >= 99 && cand_num > 1) {
    return context.text_conditionals['all-results-in-no-winner'];
  } else if (cand_num == 1) {
    return context.text_conditionals['uncontested'];
  }
}

export function determineDistrictTitle(contest) {
  return `${contest.office} ${
    contest.office === 'President' ||
    contest.division_type === 'class' ||
    contest.division_type === 'statewide'
      ? ''
      : contest.division_type === 'place' && contest.office_division === 1
      ? 'Chief Justice'
      : capfirst(contest.division_type) + ' ' + contest.office_division
  }`.trim();
}

export function determineContestTitle(contest) {
  if (contest.division_type === 'statewide' || contest.division_type === 'seat')
    return '';

  return determineDistrictTitle(contest);
}

export function determineContestTitleYourRaces(contest) {
  return determineDistrictTitle(contest);
}
